<!--
  底部菜单按钮组件
-->

<template>
  <div class="bottom_section">
    <div
      class="btn_list"
      v-for="(item, index) in btnList"
      :key="index"
      @click="handleBtn(index)"
    >
      <!-- 按钮的图标 -->
      <span class="btn_image" v-if="item.state == 0">
        <img class="btn_icon" :src="item.icon" />
        <!-- <img class="btn_back" src="@/assets/img/home_btn_back0.png" /> -->
        <!-- 按钮背景 -->
        <div class="btn_back">
          <div class="btn_line">
            <img class="btn_line1" src="@/assets/img/home_btn_line1.png" />
            <img class="btn_line2" src="@/assets/img/home_btn_line2.png" />
          </div>
          <img class="btn_bottom" src="@/assets/img/home_btn_bottom0.png" />
          <div class="flat">
            <div class="xuxian"></div>
          </div>
        </div>
      </span>
      <span class="btn_image" v-else>
        <img class="btn_icon" :src="item.checkIcon" />
        <!-- <img class="btn_back" src="@/assets/img/home_btn_back1.png" /> -->
        <!-- 按钮背景 -->
        <div class="btn_back">
          <div class="btn_line">
            <img class="btn_line1" src="@/assets/img/home_btn_line1C.png" />
            <img class="btn_line2" src="@/assets/img/home_btn_line2C.png" />
          </div>
          <img class="btn_bottom" src="@/assets/img/home_btn_bottom1.png" />
          <div class="flat">
            <div style="border-color: #038efa" class="xuxian"></div>
          </div>
        </div>
      </span>
      <!-- 按钮名称 -->
      <span :class="item.btnNameClass"
        >{{ item.name }}
        <img
          class="sep_line"
          v-if="index < 4"
          src="@/assets/img/home_btn_line.png"
      /></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "bottomSection",
  data() {
    return {
      // 按钮组
      btnList: [
        {
          name: "厂区总览",
          state: 1, // 0表示未点击,1表示已经点击
          icon: require("@/assets/img/home_btn0.png"), // 图标
          checkIcon: require("@/assets/img/home_btn0C.png"), // 选中的图标
          // 按钮名称样式
          btnNameClass: "btn_name btn_name_check",
        },
        {
          name: "工艺展示",
          state: 0, // 0表示未点击,1表示已经点击
          icon: require("@/assets/img/home_btn1.png"), // 图标
          checkIcon: require("@/assets/img/home_btn1C.png"), // 选中的图标
          btnNameClass: "btn_name",
        },
        {
          name: "巡检漫游",
          state: 0, // 0表示未点击,1表示已经点击
          icon: require("@/assets/img/home_btn2.png"), // 图标
          checkIcon: require("@/assets/img/home_btn2C.png"), // 选中的图标
          btnNameClass: "btn_name",
        },
        {
          name: "设备展示",
          state: 0, // 0表示未点击,1表示已经点击
          icon: require("@/assets/img/home_btn3.png"), // 图标
          checkIcon: require("@/assets/img/home_btn3C.png"), // 选中的图标
          btnNameClass: "btn_name",
        },
        {
          name: "统计分析",
          state: 0, // 0表示未点击,1表示已经点击
          icon: require("@/assets/img/home_btn4.png"), // 图标
          checkIcon: require("@/assets/img/home_btn4C.png"), // 选中的图标
          btnNameClass: "btn_name",
        },
      ],
      // 按钮对应的路由地址
      btnPath: [
        "/overview",
        "/pro-display",
        "/patrol",
        "/devExh",
        "/statistical",
      ],
    };
  },
  mounted() {
    this.setBtnCheck();
  },
  methods: {
    // 页面刷新后掉用此方法，控制选中按钮与路由对应
    setBtnCheck() {
      let index = this.btnPath.findIndex((item) => item == this.$route.path);
      this.btnList[0].state = 0;
      this.btnList[0].btnNameClass = "btn_name";
      this.btnList[index].state = 1;
      this.btnList[index].btnNameClass = "btn_name btn_name_check";
      // 根据下标判断页面，不同的页面有时会调用不同的初始方法
      switch (index) {
        case 2:
          document.getElementById("iframe").contentWindow.miniMapShow(true);
          break;
        case 3:
          // 调用父组件方法，重置三维视角[HomeView]组件
          this.$emit("resetView");
          break;
      }
    },
    // 按钮点击方法
    handleBtn(index) {
      // 将所有按钮样式恢复为未选中
      this.btnList = this.btnList.map((item) => {
        item.state = 0;
        item.btnNameClass = "btn_name";
        return item;
      });
      // 将点击的按钮状态修改为选中
      this.btnList[index].state = 1;
      this.btnList[index].btnNameClass = "btn_name btn_name_check";
      // 路由跳转
      this.$router.push({ path: this.btnPath[index] });
      // 调用父组件方法，重置三维视角[HomeView]组件
      this.$emit("resetView", this.btnPath[index]);
      // 根据路由控制三维小地图的显示隐藏
      if (index == 2) {
        document.getElementById("iframe").contentWindow.miniMapShow(true);
      } else {
        document.getElementById("iframe").contentWindow.miniMapShow(false);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.bottom_section {
  position: fixed;
  display: flex;
  bottom: 136vh * @vh;
  left: 50%;
  transform: translate(-50%);
  .btn_list {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    cursor: pointer;
    // 按钮图片部分
    .btn_image {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;
      top: -260vh * @vh;
      left: 220px;
      // 按钮图标
      .btn_icon {
        position: relative;
        top: 10vh * @vh;
        animation-name: icon_animation;
        animation-duration: 2s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
        /* 动画下一次播放时，逆播放 */
        animation-direction: alternate;
      }
      // 按钮背景
      .btn_back {
        height: 210px;
        position: fixed;
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          width: 100%;
          position: absolute;
        }
        // 背景中顶部两圆圈
        .btn_line {
          position: absolute;
          display: flex;
          height: 150px;
          width: 150px;
          flex-direction: column;
          align-items: center;
          .btn_line1 {
            width: 226px;
            animation-name: line1_animation;
            top: 0;
            animation-duration: 2s;
            /* 动画时间曲线 */
            animation-timing-function: ease;
            animation-iteration-count: infinite;
            /* 动画下一次播放时，逆播放 */
            animation-direction: alternate;
          }
          .btn_line2 {
            width: 312px;
            bottom: 0;
            animation-name: line2_animation;
            animation-duration: 2s;
            /* 动画时间曲线 */
            animation-timing-function: ease;
            animation-iteration-count: infinite;
            /* 动画下一次播放时，逆播放 */
            animation-direction: alternate;
          }
        }
        // 背景底座
        .btn_bottom {
          width: 276px;
          bottom: 0;
        }
        // 虚线
        .flat {
          transform: scaleY(0.375);
        }
        .xuxian {
          width: 200px;
          height: 200px;
          border-radius: 50%;
          border: 2px #fff dashed;
          transform: rotateX(45deg);
          animation-name: btn_bottom_animation;
          animation-duration: 50s;
          /* 动画时间曲线 */
          animation-timing-function: linear;
          animation-iteration-count: infinite;
        }
      }
      @keyframes icon_animation {
        0% {
          transform: translateY(0px);
        }
        100% {
          /* width: 113px; */
          transform: translateY(30vh * @vh);
        }
      }
      @keyframes line1_animation {
        0% {
          /* width: 226px; */
          transform: translateY(0px);
        }
        100% {
          /* width: 113px; */
          transform: translateY(50px);
        }
      }
      @keyframes line2_animation {
        0% {
          width: 312px;
          transform: translateY(0px);
        }
        100% {
          width: 113px;
          transform: translateY(-50px);
        }
      }
      @keyframes btn_bottom_animation {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    }
    &:nth-child(1) .btn_icon {
      width: 74px;
      height: 66vh * @vh;
    }
    &:nth-child(2) .btn_icon {
      width: 67px;
      height: 67vh * @vh;
    }
    &:nth-child(3) .btn_icon {
      width: 68px;
      height: 58vh * @vh;
    }
    &:nth-child(4) .btn_icon {
      width: 64px;
      height: 64vh * @vh;
    }
    &:nth-child(5) .btn_icon {
      width: 60px;
      height: 55vh * @vh;
    }
    .btn_name {
      color: #fff;
      font-size: 57px;
      font-family: PMZ;
      width: 490px;
      position: relative;
      left: 138px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      img {
        cursor: default;
      }
    }
    .btn_name_check {
      background-image: linear-gradient(
        to top,
        #008fff,
        #ffffff
      ); /* 线性渐变背景，方向向上 */
      -webkit-background-clip: text; /* 背景被裁剪成文字的前景色 */
      -webkit-text-fill-color: transparent; /* 文字填充颜色变透明 */
    }
    // 分隔线样式
    .sep_line {
      width: 248px;
      height: 14vh * @vh;
    }
  }
}
@media screen and (min-width: 3640px), screen and(max-height: 1080) {
  .bottom_section {
    .btn_list {
      // 按钮图片部分
      .btn_image {
        top: -450vh * @vh;
      }
      &:nth-child(1) .btn_icon {
        width: 74px;
        height: 66px;
      }
      &:nth-child(2) .btn_icon {
        width: 67px;
        height: 67px;
      }
      &:nth-child(3) .btn_icon {
        width: 68px;
        height: 58px;
      }
      &:nth-child(4) .btn_icon {
        width: 64px;
        height: 64px;
      }
      &:nth-child(5) .btn_icon {
        width: 60px;
        height: 55px;
      }
      .btn_name {
        font-size: 37px;
        width: 490px;
        left: 178px;
      }
    }
  }
}
</style>